import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { useCallback } from 'react';
import { chain } from 'react-aria';
import Dialog from './primitives/dialog.esm.js';
import AlertDialogLayout from '../layout/alert-dialog/alert-dialog.esm.js';

var _excluded = ["actionDisabled", "actionLabel", "actionSecondaryDisabled", "actionSecondaryLabel", "cancelDisabled", "cancelLabel", "children", "classNames", "closeDisabled", "hideFooter", "hideFooterBorder", "hideHeaderBorder", "onAction", "onActionSecondary", "onCancel", "onClose", "scrollBarId", "showCloseIcon", "slots", "canShrink", "title"];
function AlertDialog(_ref) {
  var actionDisabled = _ref.actionDisabled,
    actionLabel = _ref.actionLabel,
    actionSecondaryDisabled = _ref.actionSecondaryDisabled,
    actionSecondaryLabel = _ref.actionSecondaryLabel,
    cancelDisabled = _ref.cancelDisabled,
    cancelLabel = _ref.cancelLabel,
    children = _ref.children,
    classNames = _ref.classNames,
    closeDisabled = _ref.closeDisabled,
    hideFooter = _ref.hideFooter,
    hideFooterBorder = _ref.hideFooterBorder,
    hideHeaderBorder = _ref.hideHeaderBorder,
    onAction = _ref.onAction,
    onActionSecondary = _ref.onActionSecondary,
    onCancel = _ref.onCancel,
    onClose = _ref.onClose,
    scrollBarId = _ref.scrollBarId,
    showCloseIcon = _ref.showCloseIcon,
    _ref$slots = _ref.slots,
    slots = _ref$slots === void 0 ? {} : _ref$slots,
    canShrink = _ref.canShrink,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleClose = useCallback(function () {
    return onClose && onClose();
  }, [onClose]);
  return /*#__PURE__*/React__default.createElement(Dialog, _extends({
    role: "alertdialog"
  }, props, {
    canShrink: canShrink
  }), function (_ref2) {
    var close = _ref2.close;
    return /*#__PURE__*/React__default.createElement(AlertDialogLayout, {
      actionDisabled: actionDisabled,
      actionLabel: actionLabel,
      actionSecondaryDisabled: actionSecondaryDisabled,
      actionSecondaryLabel: actionSecondaryLabel,
      cancelDisabled: cancelDisabled,
      cancelLabel: cancelLabel,
      classNames: classNames,
      closeDisabled: closeDisabled,
      hideFooter: hideFooter,
      hideFooterBorder: hideFooterBorder,
      hideHeaderBorder: hideHeaderBorder,
      onAction: onAction,
      onActionSecondary: onActionSecondary,
      onCancel: onCancel,
      onClose: chain(close, handleClose),
      scrollBarId: scrollBarId,
      showCloseIcon: showCloseIcon,
      slots: slots,
      title: title,
      canShrink: canShrink
    }, children);
  });
}

export { AlertDialog as default };
//# sourceMappingURL=alert-dialog.esm.js.map
